

require("./directive.js");
define(['angular', 'squid/index'], function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-end.route', ['squid']).factory('$EndRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('EndRoute', {
      name: 'end',
      directive: 'xo-end'
    });
  });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-end/route.js
// module id = ./pages/xo-end/route.js
// module chunks = 0